(() => {
  if (!customElements.get('caffrey-step-aid')) {
    class StepAid extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController(); const {signal} = this.abort;
        this.dataset.enhanced = 'true';
        const radios = [...this.querySelectorAll('[data-sa-variant]')];
        const submit = this.querySelector('[name="add"]');
        const payment = this.querySelector('[data-sa-payment]');
        const sync = (updateUrl = false) => {
          const chosen = radios.find(r => r.checked), available = chosen?.dataset.available === 'true';
          submit.disabled = !available; submit.removeAttribute('aria-disabled');
          submit.querySelector('span').textContent = chosen ? (available ? submit.dataset.addLabel : submit.dataset.soldLabel) : submit.dataset.chooseLabel;
          if (payment) payment.hidden = !available;
          if (chosen) {
            this.querySelectorAll('[data-sa-price]').forEach(e => e.textContent = chosen.dataset.price);
            this.querySelector('product-form')?.handleErrorMessage();
            if (updateUrl) {const url = new URL(location.href);url.searchParams.set('variant', chosen.value);history.replaceState({}, '', url);}
          }
        };
        radios.forEach(r => r.addEventListener('change', () => sync(true), {signal})); sync();
        const slides = [...this.querySelectorAll('[data-sa-slide]')], dots = [...this.querySelectorAll('[data-sa-dot]')];
        let current = 0;
        const show = i => {current = (i + slides.length) % slides.length;slides.forEach((s,n) => s.hidden = n !== current);dots.forEach((d,n) => d.setAttribute('aria-current', String(n === current)));};
        this.querySelector('[data-sa-gallery-controls]').hidden = false;
        this.querySelector('[data-sa-prev]').addEventListener('click', () => show(current - 1), {signal});
        this.querySelector('[data-sa-next]').addEventListener('click', () => show(current + 1), {signal});
        dots.forEach((d,n) => d.addEventListener('click', () => show(n), {signal}));
        this.querySelector('[data-sa-gallery]').addEventListener('keydown', e => {if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {e.preventDefault();show(current + (e.key === 'ArrowLeft' ? -1 : 1));}}, {signal});
        this.querySelector('[data-sa-buy-link]')?.addEventListener('click', () => requestAnimationFrame(() => {const target = radios.find(r => r.checked) || radios.find(r => !r.disabled);target?.focus({preventScroll:true});}), {signal});
        const floating = this.querySelector('[data-sa-floating]');
        const purchase = this.querySelector('product-form');
        const refresh = () => {floating.hidden = purchase.getBoundingClientRect().bottom > 0;};
        const schedule = () => {cancelAnimationFrame(this.frame);this.frame = requestAnimationFrame(refresh);};
        window.addEventListener('scroll', schedule, {signal,passive:true});window.addEventListener('resize', schedule, {signal,passive:true});refresh();
      }
      disconnectedCallback() {this.abort?.abort();cancelAnimationFrame(this.frame);}
    }
    customElements.define('caffrey-step-aid', StepAid);
  }
  if (!customElements.get('caffrey-step-aid-features')) {
    class Features extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();this.abort = new AbortController();const {signal} = this.abort;
        const controls = [...this.querySelectorAll('[data-sa-feature]')], panels = [...this.querySelectorAll('[data-sa-panel]')];
        const select = n => {panels.forEach((p,i) => p.hidden = i !== n);controls.forEach(c => c.setAttribute('aria-pressed', String(Number(c.dataset.saFeature) === n)));};
        controls.forEach(c => {
          c.addEventListener('click', () => select(Number(c.dataset.saFeature)), {signal});
          c.addEventListener('keydown', e => {
            let n = Number(c.dataset.saFeature);
            if (['ArrowLeft','ArrowUp'].includes(e.key)) n = (n + panels.length - 1) % panels.length;
            else if (['ArrowRight','ArrowDown'].includes(e.key)) n = (n + 1) % panels.length;
            else if (e.key === 'Home') n = 0;
            else if (e.key === 'End') n = panels.length - 1;
            else return;
            e.preventDefault();select(n);this.querySelector(`.cf-sa-label[data-sa-feature="${n}"]`).focus();
          }, {signal});
        });
        this.dataset.enhanced = 'true';select(0);
      }
      disconnectedCallback() {this.abort?.abort();}
    }
    customElements.define('caffrey-step-aid-features', Features);
  }
})();
